import Breakpoint from "./breakpoint";
import Slider from "./slider";

export default (el) => {
    const slider = new Slider(el.querySelector('.slider'));
    
        console.log(el);
        slider.create();

        el.querySelector('.btn-prev').onclick = () => slider.prev();
        el.querySelector('.btn-next').onclick = () => slider.next();   
};
